import { createContext } from 'react'
//Card details
const cardContext = createContext()

export default cardContext
